var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "tab-container",
      style: { height: _vm.maxHeight - 100 + "px" }
    },
    [
      _c("customer-premises-toolbar", {
        attrs: { layer: _vm.layer, editMode: _vm.editMode }
      }),
      _vm._v(" "),
      _c("customer-premises-table", {
        attrs: {
          layer: _vm.layer,
          editMode: _vm.editMode,
          originalObjects: _vm.originalObjects,
          buildingUuid: _vm.buildingUuid
        },
        on: { updateTotalOfHPs: _vm.updateTotalOfHPs }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6d7bb71d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d7bb71d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/CustomerPremises/CustomerPremisesTab.vue
// module id = null
// module chunks = 